import { EventStatus } from "../enums/EventStatus";

export const isEventShareable = (eventStatus?: EventStatus): boolean =>
    eventStatus === EventStatus.Scheduled ||
    eventStatus === EventStatus.InProgress ||
    eventStatus === EventStatus.Completed;